<ion-header>
  <ion-toolbar class="toolbar" color="tertiary">
    <ion-buttons *ngIf="showBack" slot="start">
      <ion-button (click)="goBack()">
        <ion-icon slot="icon-only" src="./assets/icons/angle-small-left.svg" color="light"></ion-icon>
      </ion-button>
      <ion-img [src]="'./assets/logos/cmillonario-icon-lightbg.svg'"></ion-img>
      <!--<ion-img *ngIf="gameType" [src]="getLogoPath()" class="game-logo"></ion-img> -->
    </ion-buttons>
    <ion-title color="light">
      <ion-icon *ngIf="gameType" (click)="openInstructions()" name="help-circle-outline"></ion-icon>
      <!-- <span>
        {{ 'game.' + gameType + '-' + type | translate }}
      </span> -->
    </ion-title>
    <ion-buttons *ngIf="showBalance" slot="end">
      <app-wallet-btn [walletS]="walletS" [credentials]="credentials"></app-wallet-btn>
    </ion-buttons>
    <ion-progress-bar *ngIf="isLoading" color="secondary" type="indeterminate"></ion-progress-bar>
  </ion-toolbar>
</ion-header>
